export interface SiaSqlFilter {
  id: string;
  htmlContent?: string;
  icon: string;
}

export class SiaSqlFilters {
  allFilters: SiaSqlFilter[] = [
    {
      id: 'contains',
      htmlContent: '<span class="dx-icon-contains"></span> Contiene',
      icon: '<span class="dx-icon-contains"></span>',
    },
    {
      id: 'notcontains',
      htmlContent: '<span class="dx-icon-doesnotcontain"></span> Non contiene',
      icon: '<span class="dx-icon-doesnotcontain"></span>',
    },

    {
      id: '=',
      htmlContent: '<span class="dx-icon-equal"></span> Uguale',
      icon: '<span class="dx-icon-equal"></span>',
    },
    {
      id: 'startswith',
      htmlContent: '<span class="dx-icon-startswith"></span> Inizia con',
      icon: '<span class="dx-icon-startswith"></span>',
    },
    {
      id: 'endswith',
      htmlContent: '<span class="dx-icon-endswith"></span> Finisce con',
      icon: '<span class="dx-icon-endswith"></span>',
    },
    {
      id: '>',
      htmlContent: '<span class="dx-icon-greater"></span> Maggiore',
      icon: '<span class="dx-icon-greater"></span>',
    },
    {
      id: '<',
      htmlContent: '<span class="dx-icon-less"></span> Minore',
      icon: '<span class="dx-icon-less"></span>',
    },
    {
      id: '>=',
      htmlContent:
        '<span class="dx-icon-greaterorequal"></span> Maggiore o uguale',
      icon: '<span class="dx-icon-greaterorequal"></span>',
    },
    {
      id: '<=',
      htmlContent: '<span class="dx-icon-lessorequal"></span> Minore o uguale',
      icon: '<span class="dx-icon-lessorequal"></span>',
    },
    {
      id: '<>',
      htmlContent: '<span class="dx-icon-notequal"></span> Diverso',
      icon: '<span class="dx-icon-notequal"></span>',
    },
    {
      id: 'between',
      htmlContent: '<span class="dx-icon-range"></span> Compreso tra',
      icon: '<span class="dx-icon-range"></span>',
    },
    {
      id: 'anyof',
      htmlContent: '<span class="dx-icon-equal"></span> In',
      icon: '<span class=""></span>',
    },
    {
      id: 'noneof',
      htmlContent: '<span class="dx-icon-equal"></span> Non In',
      icon: '<span class=""></span>',
    },
  ];

  // { "<=", ">=", "<>", ">", "<", "=", "in", "between", "like", "not like", "is", "is not" };

  stringFilters: SiaSqlFilter[] = [
    {
      id: 'contains',
      htmlContent: '<span class="dx-icon-contains"></span> Contiene',
      icon: '<span class="dx-icon-contains"></span>',
    },
    {
      id: 'notcontains',
      htmlContent: '<span class="dx-icon-doesnotcontain"></span> Non contiene',
      icon: '<span class="dx-icon-doesnotcontain"></span>',
    },
    {
      id: 'startswith',
      htmlContent: '<span class="dx-icon-startswith"></span> Inizia con',
      icon: '<span class="dx-icon-startswith"></span>',
    },
    {
      id: 'endswith',
      htmlContent: '<span class="dx-icon-endswith"></span> Finisce con',
      icon: '<span class="dx-icon-endswith"></span>',
    },
    {
      id: '=',
      htmlContent: '<span class="dx-icon-equal"></span> Uguale',
      icon: '<span class="dx-icon-equal"></span>',
    },
    {
      id: '<>',
      htmlContent: '<span class="dx-icon-notequal"></span> Diverso',
      icon: '<span class="dx-icon-notequal"></span>',
    },
  ];
  numberFilters: SiaSqlFilter[] = [
    {
      id: '=',
      htmlContent: '<span class="dx-icon-equal"></span> Uguale',
      icon: '<span class="dx-icon-equal"></span>',
    },
    {
      id: '>=',
      htmlContent:
        '<span class="dx-icon-greaterorequal"></span> Maggiore o uguale',
      icon: '<span class="dx-icon-greaterorequal"></span>',
    },
    {
      id: '<=',
      htmlContent: '<span class="dx-icon-lessorequal"></span> Minore o uguale',
      icon: '<span class="dx-icon-lessorequal"></span>',
    },
    {
      id: '>',
      htmlContent: '<span class="dx-icon-greater"></span> Maggiore',
      icon: '<span class="dx-icon-greater"></span>',
    },
    {
      id: '<',
      htmlContent: '<span class="dx-icon-less"></span> Minore',
      icon: '<span class="dx-icon-less"></span>',
    },

    {
      id: '<>',
      htmlContent: '<span class="dx-icon-notequal"></span> Diverso',
      icon: '<span class="dx-icon-notequal"></span>',
    },
  ];
  dateFilters: SiaSqlFilter[] = [
    {
      id: '>=',
      htmlContent:
        '<span class="dx-icon-greaterorequal"></span> Maggiore o uguale',
      icon: '<span class="dx-icon-greaterorequal"></span>',
    },
    {
      id: '<=',
      htmlContent: '<span class="dx-icon-lessorequal"></span> Minore o uguale',
      icon: '<span class="dx-icon-lessorequal"></span>',
    },
    {
      id: '>',
      htmlContent: '<span class="dx-icon-greater"></span> Maggiore',
      icon: '<span class="dx-icon-greater"></span>',
    },
    {
      id: '<',
      htmlContent: '<span class="dx-icon-less"></span> Minore',
      icon: '<span class="dx-icon-less"></span>',
    },
    {
      id: '=',
      htmlContent: '<span class="dx-icon-equal"></span> Uguale',
      icon: '<span class="dx-icon-equal"></span>',
    },
    {
      id: 'between',
      htmlContent: '<span class="dx-icon-range"></span> Compreso tra',
      icon: '<span class="dx-icon-range"></span>',
    },
  ];

  additionalFilters: SiaSqlFilter[] = [
    {
      id: 'anyof',
      htmlContent: '<span class="dx-icon-equal"></span> In',
      icon: '<span class=""></span>',
    },
    {
      id: 'noneof',
      htmlContent: '<span class="dx-icon-equal"></span> Non In',
      icon: '<span class=""></span>',
    },
  ];
}
